<template lang="pug">
  <div>
    el-dialog(:title="!dataForm.id ? '新增' : '修改'", :close-on-click-modal='false', :visible.sync='visible' :modal-append-to-body='false' ,@open='diaopen')
      el-form(:model='dataForm', :rules='dataRule', ref='dataForm', @keyup.enter.native='dataFormSubmit()', label-width='80px')
        el-form-item(label='场馆名称', prop='name')
          el-input(v-model='dataForm.name', placeholder='请填写场馆名称')
        el-form-item(label='站点', prop='area')
          el-input(v-model='dataForm.area' , placeholder='请填写站点名称')
        div(style="display: flex;")
          el-form-item(label='地区:' prop='proviceId')
              el-select(v-model="dataForm.proviceId" placeholder="请选择" @change="changeProvice")
                  el-option(v-for="(item, index) in proviceList" :key="index" :label="item.name" :value="item.proviceId")
              font(style="margin: 0 12px;") 省
          el-form-item(label-width='0' prop='cityId')
              el-select(v-model="dataForm.cityId" placeholder="请选择")
                el-option(v-for="(item, index) in cityList" :key="index" :label="item.cityname" :value="item.cityId")
              font(style="margin: 0 12px;") 市
        el-form-item(label='场馆地址', prop='address')
          el-input(v-model='dataForm.address', placeholder='请填写场馆地址' , id="suggestId" ,@input="searchInput" @blur="searchblur" ,@focus="setmp")
        el-form-item(label='主办方', prop='orgId')
          el-select(v-model="dataForm.orgId",placeholder="请选择" filterable clearable)
              el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId")
        el-form-item(label='联系电话', prop='tel')
          el-input(v-model='dataForm.tel', placeholder='请填写联系方式')
        div(id="container" v-if="false")
        el-form-item(label='场馆介绍', prop='detail')
          d2-quill(style="min-height: 200px;",ref="d2-quill" v-model="dataForm.detail")
      span.dialog-footer(slot='footer')
        el-button(@click='visible = false') 取消
        el-button(type='primary', @click='dataFormSubmit()' :disabled="clickFlag") 确定
  </div>
</template>

<script>
import value from './value'
// import { TMap } from './TMap'
import { setTimeout } from 'timers'
var map
var geocoder
export default {
  data () {
      var validateAddress = (rule, value, callback) => {
          var _this = this
          var address = _this.dataForm.address
          if (address) {
              // geocoder = new qq.maps.Geocoder()
              // //对指定地址进行解析
              // geocoder.getLocation(address)

              // //设置服务请求成功的回调函数
              // geocoder.setComplete(function (result) {
              //     _this.dataForm.longitude = result.detail.location.lng
              //     _this.dataForm.latitude = result.detail.location.lat
              //     // console.log(_this.dataForm.longitude, _this.dataForm.latitude, 9999)
              //     callback()
              // })
              // //若服务请求失败，则运行以下函数
              // geocoder.setError(function () {
              //     callback(new Error('获取经纬度失败，请重新选择地址！'))
              // })
              callback()
          } else {
              callback(new Error('场馆地址不能为空！'))
          }
      }
    return {
      clickFlag: false,
      userlocation: { lng: '', lat: '' },
      znxxl: '',
      visible: false,
      proviceList: [],
      cityList: [],
      sysOrgList: [],
      dataForm: {
        id: 0,
        name: '',
        area: '',
        proviceId: '',
        cityId: '',
        address: '',
        orgId: '',
        tel: '',
        detail: '',
        longitude: '',
        latitude: '',
        provinceName: '',
        cityName: ''
      },
      loading: null,
      dataRule: {
        name: [
          { required: true, message: '场馆名称不能为空！', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
         area: [
          { required: true, message: '站点名称不能为空！', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        proviceId: [
          { required: true, message: '必须选择省！', trigger: 'change' }
        ],
        cityId: [
          { required: true, message: '必须选择市！', trigger: 'change' }
        ],
         address: [
          { required: true, message: '必须选择地区！', trigger: 'change' },
          { validator: validateAddress, trigger: 'change' },
          { validator: validateAddress, trigger: 'blur' }
        ],
        orgId: [
          { required: true, message: '主办方不能为空！', trigger: 'change' }
        ],
        tel: [
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {

        //      TMap('OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77').then(qq => {
        //      map = new qq.maps.Map(document.getElementById("container"), {
        //         // 地图的中心地理坐标。
        //         center: new qq.maps.LatLng(39.916527, 116.397128),
        //          zoom: 8
        //     });
        //     // qq.maps.event.addListener(map, 'click', function(event) {
        //     //     alert('您点击的位置为: [' + event.latLng.getLat() + ', ' +
        //     //       event.latLng.getLng() + ']')
        //     //   })
        // });
  },
  methods: {
    init (id) {
        this.clickFlag = false
      this.changeCity()
      this.dataForm.id = id || 0
      this.proviceList = []
      this.cityList = []
      this.sysOrgList = []
      this.dataForm.proviceId = ''
      this.dataForm.cityId = ''
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        this.proviceList = data && data.code === 0 ? data.list : []
      }).then(() => {
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          console.log(this.$refs['d2-quill'])
           this.$refs['d2-quill'].Quill.pasteHTML('')
        })
      }).then(() => {
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/pbPlaces/getId/${this.dataForm.id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
              this.dataForm.name = data.bean.name
              this.dataForm.area = data.bean.area
              this.dataForm.proviceId = data.bean.provinceCode
              this.dataForm.cityId = data.bean.cityCode
              this.dataForm.address = data.bean.address
              this.dataForm.orgId = data.bean.orgId
              this.dataForm.tel = data.bean.tel
              this.dataForm.detail = data.bean.detail
              this.value = data.bean.detail
              this.dataForm.detail = `${data.bean.detail}`
               this.$nextTick(() => {
                   this.$refs['d2-quill'].Quill.pasteHTML(data.bean.detail)
                 })
          }
           this.changeProvice(0)
          })
        }
      })
    },
      openFullScreen () {
          this.loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
          })
      },
    changeProvice (flag) {
        let obj = {}
        let val = this.dataForm.proviceId
        obj = this.proviceList.find((item) => {
            return item.proviceId === val
        })
        this.dataForm.provinceName = obj.name
      if (flag != 0) {
                this.cityList = []
                this.dataForm.cityId = ''
          }
          this.$http({
            url: this.$http.adornUrl('/dicProvinceCity/list'),
            method: 'get',
            params: this.$http.adornParams({
                'proviceId': this.dataForm.proviceId
        })
          }).then((data) => {
            this.cityList = data && data.code === 0 ? data.list : []
            // this.dataForm.cityId = this.cityList[0].cityId
          })
    },
    changeCity () {
        let obj = {}
        let val = this.dataForm.cityId
        if (val) {
            obj = this.cityList.find((item) => {
                return item.cityId === val
            })
        }
        this.dataForm.cityName = obj.cityname
          this.$http({
            url: this.$http.adornUrl('/sysOrg/list'),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            this.sysOrgList = data && data.code === 0 ? data.list : []
          })
    },
    searchInput () {
      // console.log('input');
      // 控制只能选地址
      this.znxxl = 0
    },
    setmp () {
       this.znxxl = 1
    },
    searchblur () {
      // console.log(document.getElementById("suggestId").value)
      // this.dataForm.address = document.getElementById("suggestId").value
    },

    diaopen () {
      
      this.$nextTick(() => {
        var _this = this
        setTimeout(() => {
          // JS
          // 腾讯地图
          // 腾讯地图API功能
          var myLatlng = new qq.maps.LatLng(39.916527, 116.397128)
          // var myOptions = {
          //     zoom: 12,
          //     center: myLatlng
          // }
          // var map = new qq.maps.Map('l-map', myOptions)
          //实例化自动完成,需要引入libraries=place库，不是autocomplete库。
  
          var ap = new qq.maps.place.Autocomplete(document.getElementById('suggestId'))
          //调用Poi检索类。用于进行本地检索、周边检索等服务。
          // var searchService = new qq.maps.SearchService({
          //     map: map
          // })
          //添加监听事件
          qq.maps.event.addListener(ap, 'confirm', function (res) {
            // console.log(ap.place.address, res, 999)
            _this.dataForm.address = ap.place.address + res.value
            // searchService.search(ap.place.address + res.value);
          })
        }, 500)
      })

  //     setTimeout(() => {
  //   this.$nextTick( ()=> {
  //     var th = this
  //     // 创建Map实例
  //     let map = new BMap.Map(document.getElementById("allmap"));
  //     // 初始化地图,设置中心点坐标，
  //     var point = new BMap.Point(39.916527, 116.397128);
  //     map.centerAndZoom(point, 15);
  //     map.enableScrollWheelZoom();
  //     var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
  //         {
  //             "input": "suggestId",
  //             "location": map
  //         })
  //     var myValue
  //     ac.addEventListener("onconfirm", function (e) {    //鼠标点击下拉列表后的事件
  //         var _value = e.item.value;
  //         myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
  //         th.dataForm.address = myValue
  //        // setPlace();
  //     });
  //     function setPlace() {
  //         map.clearOverlays();    //清除地图上所有覆盖物
  //         function myFun() {
  //             th.userlocation = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
  //             map.centerAndZoom(th.userlocation, 18);
  //             map.addOverlay(new BMap.Marker(th.userlocation));    //添加标注
  //         }
  //         var local = new BMap.LocalSearch(map, { //智能搜索
  //             onSearchComplete: myFun
  //         })
  //         local.search(myValue)
  //     }
  //   })

  // }, 0)

  //     let that = this
  //     setTimeout(()=>{
  //       // console.log(that.dataForm.address,123);
  //       document.getElementById("suggestId").value = that.dataForm.address
  //       let xiala = document.querySelectorAll(".tangram-suggestion-main")
  //       if(xiala) {
  //         // console.log(123);
  //         xiala.forEach(e => {
  //           e.style.display = 'none'
  //         })
  //         // console.log(xiala.style.display);
  //       }
  //     },500)
    },
    // 表单提交
    dataFormSubmit () {
      console.log(this.dataForm.address)

      this.$refs['dataForm'].validate((valid) => {
          if (valid) {
           // this.openFullScreen()
              this.clickFlag = true
              this.dataForm.cityName = this.cityList.find(item => item.cityId === this.dataForm.cityId).cityname
          this.$http({
            url: this.$http.adornUrl(`/pbPlaces/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: {
              'id': this.dataForm.id || undefined,
              'name': this.dataForm.name,
              'area': this.dataForm.area,
              'provinceCode': this.dataForm.proviceId,
              'cityCode': this.dataForm.cityId,
              'address': this.dataForm.address,
              'orgId': this.dataForm.orgId,
              'tel': this.dataForm.tel,
              'detail': this.dataForm.detail,
              'longitude': this.dataForm.longitude,
              'latitude': this.dataForm.latitude,
              'provinceName': this.dataForm.provinceName,
              'cityName': this.dataForm.cityName

            }
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                 // this.loading.close()
                  this.visible = false
                  this.$emit('refreshdatalist')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
   }
 }
</script>
<style>
#container {
    min-width:600px;
    min-height:767px;
}
#allmap{
  width: 100px;
  height: 100px;
  border: 1px solid #000;
}
</style>
